import React from 'react'
import PropTypes from 'prop-types'
import { useCallback, useFeatures } from 'sb-hooks'
import { constants, links, mixpanel } from 'common/helpers'
import actions from 'redux/actions'

import Text from 'components/_new/typography/Text/Text'
import Button from 'components/_new/Button/Button'
import Box from 'components/_new/layout/Box/Box'
import ResubscribeNowButton from 'components/buttons/ResubscribeNowButton/ResubscribeNowButton'
import BuyApplePayButton from 'components/buttons/applePay/BuyApplePayButton/BuyApplePayButton'

import messages from './messages'
import s from './Offer.scss'


const Offer = ({ className, isSubscriptionCancelled, isMobile, placement }) => {
  const buttonHeight = isMobile ? '12vw' : '46px'

  const {
    [constants.features.applePay]: isApplePayEnabled,
  } = useFeatures()

  const handleSubscribeClick = useCallback(() => {
    mixpanel.track(constants.analyticsEvents.subscribeButtonClick, { placement })

    actions.view.paymentPage.fetchDiscount({
      code: constants.discountCoupons['25_off'],
      plan: constants.planNames.monthly[1],
    }).finally(() => {
      actions.models.router.push(links.subscribe)
    })
  }, [ placement ])

  return (
    <div className={className}>
      <Box mb={isMobile ? '24' : '16'}>
        <Text className={s.text} message={messages.text} html />
      </Box>
      <div className={s.buttons}>
        {
          isSubscriptionCancelled ? (
            <ResubscribeNowButton
              placement={placement}
              resubscribeCode={constants.resubscribeTypes.resub25}
              className={s.button}
            />
          ) : (
            <Button
              onClick={handleSubscribeClick}
              className={s.button}
              uppercase
              color="brand"
              size="md"
              weight="normal"
              title={messages.subscribe}
            />
          )
        }
        {
          isApplePayEnabled && (
            <BuyApplePayButton
              className={s.button}
              height={buttonHeight}
              couponCode={constants.discountCoupons['25_off']}
              placement="queue page"
            />
          )
        }
      </div>
    </div>
  )
}

Offer.propTypes = {
  className: PropTypes.string,
  isMobile: PropTypes.bool,
  isSubscriptionCancelled: PropTypes.bool,
  placement: PropTypes.string,
}

Offer.defaultProps = {
  placement: 'queue page',
}


export default Offer
